//Import Highcharts
import Highcharts from "highcharts";
global.Highcharts = Highcharts;
window.Highcharts = Highcharts;

import HighchartsDrilldown from "highcharts/modules/drilldown";
import HighchartsExporting from "highcharts/modules/exporting";

// Inicializando os módulos
HighchartsDrilldown(Highcharts);
HighchartsExporting(Highcharts);